<template>
  <div class="tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]">
    <div
      id="assessment-sub-category-question-header"
      :class="`tw-cursor-pointer tw-select-none tw-pr-[25px] tw-bg-[#FCFCFD] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-0 tw-border-b-[1px] tw-border-solid  tw-border-[#EFF0F1] ${
        showIcon ? 'tw-rounded-[6px]' : 'tw-rounded-t-[6px]'
      }`"
      @click="collapseCategory"
      @mouseover="onHoverIn"
      @mouseout="onHoverOut"
    >
      <div
        class="tw-flex tw-flex-row tw-justify-start tw-items-center tw-py-[20px]"
      >
        <CustomCheckBox
          v-model:is-checked="selectAll"
          class="tw-h-[20px] tw-ml-[25px] !tw-mb-0"
          size="20px"
          @update:is-checked="handleSelfCheck"
        />
        <div
          class="tw-pr-[19px] w-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]"
        >
          <span>{{ orderNumber }}.</span>
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <div
            id="assessment-sub-category-name"
            class="tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]"
          >
            {{
              questionFormat.checklistItemHeadingLabel ||
              questionFormat.checklistItemName ||
              ""
            }}
            {{ questionFormat.subName ? ` | ${questionFormat.subName}` : "" }}
          </div>
          <ButtonShowDuplicateAssessment
            v-if="
              (questionFormat.checklistItemDescription ||
                questionFormat.checklistItemGuidance) &&
              onHover
            "
            :id-popover="'popover-assessment-sub-category-' + orderNumber"
            :custom-class="'tw-w-[max-content] tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
            :class="`!tw-p-0 tw-leading-[16px]`"
            :classes="`!tw-leading-none`"
          >
            <div class="tw-p-[15px] tw-w-[475px]">
              <div
                class="tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]"
              >
                <div v-if="questionFormat.checklistItemDescription">
                  <div
                    class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                  >
                    {{
                      getComponentUiText(
                        "app-menu-submenu-assessments-further-information-1",
                      )
                    }}
                  </div>
                  <CustomDescriptionContent
                    :description="questionFormat.checklistItemDescription"
                    :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                  >
                  </CustomDescriptionContent>
                </div>
                <div v-if="questionFormat.checklistItemGuidance">
                  <div
                    class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                  >
                    {{
                      getComponentUiText(
                        "app-menu-submenu-assessments-guidance-1",
                      )
                    }}
                  </div>
                  <CustomDescriptionContent
                    :description="questionFormat.checklistItemGuidance"
                    :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                  >
                  </CustomDescriptionContent>
                </div>
              </div>
            </div>
          </ButtonShowDuplicateAssessment>
        </div>

        <div class="tw-flex tw-flex-row">
          <div class="tw-flex tw-mx-[15px] tw-gap-3">
            <div
              v-show="isCheckComplete"
              :class="`complete tw-flex tw-w-full tw-justify-center tw-items-center tw-gap-[5px] tw-rounded-[4px] tw-py-[3px] tw-px-[5px] `"
            >
              <span
                class="tw-text-[#01893D] tw-text-[11px] tw-font-Poppins tw-font-[500]"
                >{{
                  getComponentUiText(
                    "app-component-assessments-checklists-assessment-details-card-status-3",
                  )
                }}
              </span>
              <div class="tw-w-[12px] tw-h-[12px] tw-inline-flex">
                <circularProgress
                  class="tw-w-[12px] tw-h-[12px]"
                  :percent="100"
                />
              </div>
            </div>
            <div
              v-show="isCheckExposure"
              :class="`exposure tw-flex tw-w-full tw-justify-center tw-items-center tw-gap-[5px] tw-rounded-[4px] tw-py-[3px] tw-px-[5px] `"
            >
              <span
                class="tw-text-[#F7553C] tw-text-[11px] tw-font-Poppins tw-font-[500]"
                >{{
                  getComponentUiText(
                    "app-menu-submenu-assessments-scanning-exposure-1",
                  )
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div>
        <span class="float-right button-arrow dropdown-button-arrow-img">
          <img
            v-if="showIcon || null"
            class="dropdown-button-arrow-img"
            src="@/assets/img/arrow_down2.svg"
          />
          <img
            v-else
            class="collap-button-arrow-down-img"
            src="@/assets/img/arrow_down2.svg"
          />
        </span>
      </div>
    </div>
    <div
      v-if="
        questionFormat.checklistChildren &&
        questionFormat.checklistChildren.length === 0 &&
        !showIcon &&
        hideComplete
      "
      class="tw-p-[25px] tw-bg-white tw-border-solid tw-border-[1px] tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-[#EFF0F1] tw-rounded-b-[6px]"
    >
      <div
        class="tw-flex tw-items-center tw-justify-between empty-question tw-rounded-[6px] tw-px-[20px] tw-py-[14px]"
      >
        <p
          class="tw-m-0 tw-text-[#FE9A05] tw-text-[13px] tw-leading-[145%] tw-font-[400]"
        >
          {{ getComponentUiText("app-assessment-input-empty-data-filter-1") }}
        </p>
        <p
          class="tw-m-0 tw-text-[#387DFF] tw-text-[11px] tw-leading-[145%] tw-font-[500] tw-cursor-pointer"
          @click="emit('clearFilter')"
        >
          {{ getComponentUiText("app-assessment-input-clear-filter-button-1") }}
        </p>
      </div>
    </div>
    <div v-if="!showIcon" id="assessment-sub-category-question-content">
      <assessmentQuestion
        v-for="(item, index) in questionFormat.checklistChildren"
        :id="String(item.checklistItemId as any)"
        :key="item.checklistItemId"
        v-memo="[item, selectedQuestions]"
        :index="index"
        class="question"
        :checklist-item="item"
        :checklist-item-id="item.checklistItemId"
        :checklist-id="questionFormat.checklistItemId"
        :suggestion="item?.suggestion"
        :is-selected="selectedQuestions.includes(item.checklistItemId)"
        :is-assessment-input="true"
        :selected-questions="selectedQuestions"
        :is-exclude="isExclude"
        :checklist-item-is-excluded="item.checklistItemIsExcluded"
        :is-in-other-category="
          questionFormat.checklistItemHeadingLabel === 'Other'
        "
        @update:selected-questions="handleUpdateSelectedQuestions($event)"
        @open-evidence-modal="
          () =>
            openAddEvidence(
              item,
              `${orderNumber}.${index + 1}`,
              item.additionalData?.filter(
                (i) => i.type === assessmentAdditionalInfoType.attachment,
              )[0]?.attachments,
            )
        "
        @exclude="
          (id) => emit('excludeItem', id, questionFormat.checklistItemId, item)
        "
        @update:child-answer="
          (values) => handleUpdateChildAnswer(values, index)
        "
        @update:answer="
          (value) =>
            handleUpdateAnswer(
              value,
              questionFormat.checklistItemId,
              item,
              index,
            )
        "
      >
        {{ item.checklistItemHeadingLabel || item.checklistItemName }}
        {{ item.subName ? ` | ${item.subName}` : "" }}
      </assessmentQuestion>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  ComputedRef,
  onMounted,
  PropType,
  Ref,
  ref,
  watch,
} from "vue";
import circularProgress from "./circularProgress.vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import assessmentQuestion from "@/components/assessments/assessmentQuestion.vue";
import { IAssessmentChecklistItem } from "@/interfaces/assessments/IAssessmentDetails";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  assessmentAdditionalInfoType,
  assessmentQuestionVisibleState,
  checklistStatusId,
} from "@/utils/constants";
import store from "@/store";
import { getComponentUiText, getParent } from "@/utils/utilities";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";

const props = defineProps({
  /** The order number of sub question category */
  orderNumber: {
    type: [Number, String],
    default: 1,
  },
  /** sub sub categories */
  question: {
    type: Object as PropType<IAssessmentChecklistItem>,
    required: true,
  },
  isExclude: {
    type: Boolean,
    default: false,
  },
  selectedQuestions: {
    type: Array as () => any[],
    default: () => [],
  },
  hideComplete: {
    type: [Boolean, Object],
    default: false,
  },
});
const selectAll: Ref<boolean> = ref(false);
const showIcon: Ref<boolean> = ref(false);
const isComplete: Ref<boolean> = ref(true);
const onHover: Ref<boolean> = ref(false);
const questionFormat: Ref<IAssessmentChecklistItem> = ref({
  ...props.question,
} as IAssessmentChecklistItem);
const activeEvidenceData: any = ref({});
let setTimeOutRef: any = null;

onMounted(() => initial());

const initial = () => {
  checkStatus(questionFormat.value.checklistChildren);
};

const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};

const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 150);
};

const isCheckComplete = computed(() => {
  if (questionFormat.value.checklistChildren) {
    return questionFormat.value.checklistChildren.every((child) => {
      if (child.checklistItemHasChildren)
        return child.checklistChildren?.every((el) => {
          return (
            el.itemCompleteValue !== undefined ||
            el.visibleState === assessmentQuestionVisibleState.no
          );
        });
      return (
        child.itemCompleteValue !== undefined ||
        child.visibleState === assessmentQuestionVisibleState.no
      );
    });
  }
  return questionFormat.value.checklistChildren?.every((child) => {
    return (
      child.itemCompleteValue !== undefined ||
      child.visibleState === assessmentQuestionVisibleState.no
    );
  });
});

const isCheckExposure = computed(() => {
  let isExposure: boolean | undefined = false;
  isExposure = questionFormat.value.checklistChildren?.some((child) => {
    return (
      Number(child.itemCompleteValue) >= 0 &&
      child.itemCompleteValue !== undefined
    );
  });

  if (isCheckComplete.value) {
    isExposure = !questionFormat.value.checklistChildren?.every((child) => {
      return child.itemCompleteValue === 100;
    });
  }

  return isExposure;
});

const collapseCategory = () => (showIcon.value = !showIcon.value);

const handleUpdateAnswer = (
  value: any,
  checklistId: any,
  item: any,
  index: any,
) => {
  questionFormat.value.checklistChildren[
    index
  ].checklistItemComplianceTypeValue = value;
  setTimeout(() => {
    store.dispatch("Assessment/updateAnswer", {
      checklistId: checklistId,
      checklistItemId: item.checklistItemId,
      answer: value,
      type: ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_TYPE_VALUE,
    });
  }, 0);
};

const handleUpdateChildAnswer = (values: any, index: any) => {
  if (
    questionFormat.value.checklistChildren[index].checklistChildren[
      values.index
    ]
  ) {
    questionFormat.value.checklistChildren[index].checklistChildren[
      values.index
    ].checklistItemComplianceTypeValue = values.answer;
  }
  setTimeout(() => {
    store.dispatch("Assessment/updateAnswer", {
      checklistId: values.item.checklistId,
      checklistItemId: values.questionFormat,
      answer: values.answer,
      type: ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_TYPE_VALUE,
    });
  }, 0);
};

const checkStatus = async (
  children: IAssessmentChecklistItem[] | undefined,
) => {
  if (!children) {
    isComplete.value = false;
    return;
  }

  children.map((subCate) => {
    if (subCate.checklistItemComplianceTypeValue !== 1) {
      isComplete.value = false;
      return;
    }
  });
};

const emit = defineEmits([
  "open-evidence-modal",
  "close-evidence-modal",
  "excludeItem",
  "update:selectedQuestions",
  "clearFilter",
]);

watch(
  () => props.question,
  () => {
    questionFormat.value = { ...props.question } as IAssessmentChecklistItem;
    initial();
  },
  { deep: true },
);

watch(
  () => props.selectedQuestions,
  () => {
    checkIsAllSelected();
  },
);

onMounted(() => {
  checkIsAllSelected();
});

const openAddEvidence = (
  item: any,
  showIndex: any,
  attachments: any[] = [],
) => {
  activeEvidenceData.value.subCategory =
    questionFormat.value.checklistItemHeadingLabel ||
    questionFormat.value.checklistItemName;
  activeEvidenceData.value.questionNumber = showIndex;
  activeEvidenceData.value.questionTitle = item.checklistItemName;
  const attachmentsTemp = attachments.map((attachment, index) => ({
    ...attachment,
    name: attachment.name,
    size: attachment.fileSizeBytes,
    dateAdded: attachment.dateAdded,
    date: attachment.dateAdded ? new Date(attachment.dateAdded) : "",
    addedByUserId: attachment.addedByUserId,
    uploadedBy: {
      nameText: attachment.addedByUserId,
      email: attachment.addedByUserId,
    },
    id: attachment.attachmentId || index,
  }));
  emit("open-evidence-modal", activeEvidenceData.value, attachmentsTemp);
};

const handleSelfCheck = (isSelected: boolean) => {
  const allChild = [props.question.checklistItemId];
  const question = props.question.checklistChildren || [];
  const loop = (array?: any[]) => {
    const output: any[] = [];
    (array || []).forEach((item) => {
      output.push(item.checklistItemId);
      output.push(...loop(item.checklistChildren));
    });
    return output;
  };
  allChild.push(...loop(question));

  const output = isSelected
    ? Array.from(new Set([...props.selectedQuestions, ...allChild]))
    : props.selectedQuestions.filter(
        (checklistItemId) => !allChild.includes(checklistItemId),
      );
  return emit("update:selectedQuestions", output);
};

const handleUpdateSelectedQuestions = (payload: {
  item: any;
  selected: boolean;
  level: number;
}) => {
  const { item, selected, level } = payload;
  let i = level;
  let parent = item;
  const arrParent: number[] = [];
  const parents: any = [];
  while (i > -1) {
    parent = getParent(parent, props.question);
    if (parent) {
      arrParent.push(parent.checklistItemId);
      parents.push(parent);
    }
    i -= 1;
  }

  const loopChild = (data: any) => {
    const output: any[] = [];
    (data.checklistChildren || []).forEach((child: any) => {
      output.push(child.checklistItemId);
      output.push(...loopChild(child));
    });
    return output;
  };
  const arrChild = loopChild(item);

  // add
  if (selected) {
    const output = Array.from(
      new Set([...props.selectedQuestions, item.checklistItemId, ...arrChild]),
    );
    parents.forEach((parent: any) => {
      const hasSelect = parent.checklistChildren.every((child: any) =>
        output.includes(child.checklistItemId),
      );
      if (hasSelect) {
        output.push(parent.checklistItemId);
      }
    });
    return emit("update:selectedQuestions", output);
  }

  // prune
  const output = props.selectedQuestions.filter(
    (order) =>
      !(
        arrChild.includes(order) ||
        arrParent.includes(order) ||
        item.checklistItemId === order
      ),
  );
  return emit("update:selectedQuestions", output);
};

const checkIsAllSelected = () => {
  const allQuestion = props.question?.checklistChildren || [];
  selectAll.value = allQuestion.every((item) =>
    props.selectedQuestions.includes(item.checklistItemId),
  );
};
</script>
<style>
.complete {
  background: linear-gradient(
      0deg,
      rgba(1, 137, 61, 0.15) 0%,
      rgba(1, 137, 61, 0.15) 100%
    ),
    #fff;
}

.exposure {
  background: linear-gradient(
      0deg,
      rgba(247, 85, 60, 0.15) 0%,
      rgba(247, 85, 60, 0.15) 100%
    ),
    #fff;
}

.collap-button-arrow-down-img {
  transform: rotate(180deg);
}

.question:last-child {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.text-with-icon {
  display: inline-block;
  margin: 0;
}

.info-icon {
  margin-left: 5px;
  vertical-align: middle;
}

.empty-question {
  background: var(
    --placeholder-orange-soft,
    linear-gradient(
      0deg,
      rgba(254, 154, 5, 0.15) 0%,
      rgba(254, 154, 5, 0.15) 100%
    ),
    #fff
  );
}
</style>
